import React from "react";
import ptLogo from "../../assets/persbetechLogo3.png";
import "./footer.css";

const Footer = () => {
  return (
    <div className="pt__footer section__padding">
      {/* <div className="pt__footer-heading">
      <h1 className="gradient__text">Are you interested in doing business with us?</h1>
    </div>

    <div className="pt__footer-btn">
      <p>Contact us</p>
    </div> */}

      <div className="pt__footer-links">
        <div className="pt__footer-links_logo">
          <img src={ptLogo} alt="pt_logo" />
          {/* <p>Baatsona, Accra <br /> All Rights Reserved</p> */}
        </div>
        <div className="pt__footer-links_div">
          <h4>Locations</h4>
          <p>Baatsona</p>
        </div>
        <div className="pt__footer-links_div">
          <h4>Company</h4>
          <p>Terms & Conditions </p>
          <p>Privacy Policy</p>
        </div>
        <div className="pt__footer-links_div">
          <h4>Get in touch</h4>
          <p>Tel: +233538574403</p>
          <p>Facebook</p>
          <p>Instagram</p>
          <p>persbetech@gmail.com</p>
        </div>
      </div>

      <div className="pt__footer-copyright">
        <p>@2020 PersbeTech. All rights reserved.</p>
      </div>
    </div>
  );
};

export default Footer;
